import React from 'react';

export const LoaderButton = () => <div className="button loader-button"></div>;
